module.exports = __webpack_public_path__ + "img/baohu.cb80a68e.png";